import { DEFAULT_STC_CURRENCY, PRICELESS_CURRENCY_OBJ } from "@stadium/constants/currency";

export const convertPrice = (
  { from, to, value, conversionRates },
  { ceilRequired = false } = {},
) => {
  const amountInBaseCurrency =
    from && to
      ? (value / conversionRates[from.toLowerCase()]) * conversionRates[to.toLowerCase()]
      : value;
  if (ceilRequired) return Math.ceil(amountInBaseCurrency);
  return parseFloat(amountInBaseCurrency?.toFixed(2) || 0);
};

export const formatPrice = (
  number,
  { prefix = "", suffix = "", currencyCode = "", currencyDisplay = "" } = {},
) => {
  if (isCustomCurrency(currencyCode) || !currencyCode) {
    const fractionDigits = number % 1 == 0 ? 0 : 2;
    const currencyFormatter = new Intl.NumberFormat(undefined, {
      maximumFractionDigits: fractionDigits,
      minimumFractionDigits: fractionDigits,
      ...(currencyDisplay && { currencyDisplay }),
    });
    const displayPrice = currencyFormatter.format(number);
    return `${prefix}${displayPrice} ${suffix}`.trim();
  } else {
    const fractionDigits = number % 1 == 0 ? 0 : 2;
    const currencyFormatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: currencyCode,
      maximumFractionDigits: fractionDigits,
      minimumFractionDigits: fractionDigits,
      ...(currencyDisplay && { currencyDisplay }),
    });
    return currencyFormatter.format(number);
  }
};

export const isCustomCurrency = (code = "") => code.startsWith(DEFAULT_STC_CURRENCY.code);

export const getCurrencyOptions = (conversionRates) => {
  return {
    stc: {
      key: "stc",
      type: "STC",
      label: "Points",
      text: "Points",
      description: `Short name: Pts, Conversion 1 USD = ${conversionRates.stc} Pts`,
    },
    usd: {
      key: "usd",
      type: "USD",
      label: "US Dollars",
      text: "US Dollars",
      description: "Short name: USD",
    },
    priceless: PRICELESS_CURRENCY_OBJ,
  };
};
